import { MeasurableGroupType } from '@upright/common/model/input/measurable-group/types';
import { EmptyStateNoDataAccess } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/no-access';
import { EmptyStateNoData } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/no-data';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import {
  LensDataAccess,
  LensDataAvailability,
  SingleEntityLensData,
} from '@upright/ui/common/upright/core/impact-lens-profile/types';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { EmptyStateUnweightedPortfolio } from './unweighted-portfolio';

interface Props {
  dataTitle: string;
  noDataMessage?: string; // TODO: maybe turn to function of entity, so that company name can be included in message
}

export function GenericEmptyState(props: Props) {
  const { dataTitle } = props;
  const ctx = useCarouselContext();
  const data = ctx.data as SingleEntityLensData<ImpactLensType>;

  const groupTypeOrUndefined = data.groupType;

  const accessDenied = data.access === LensDataAccess.DENIED;
  if (accessDenied) {
    return <EmptyStateNoDataAccess />;
  }

  const unweightedPortfolio = groupTypeOrUndefined === MeasurableGroupType.UNWEIGHTED_PORTFOLIO;
  if (unweightedPortfolio) {
    return <EmptyStateUnweightedPortfolio />;
  }

  const unavailable = data.availability === LensDataAvailability.UNAVAILABLE;
  if (unavailable) {
    return <EmptyStateNoData dataTitle={dataTitle} message={props.noDataMessage} />;
  }
  return <></>;
}
